import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';

/**
 * ✅ 공통 다이얼로그(오버레이 + 패널) 베이스
 * - backdrop 클릭으로 닫기(옵션)
 * - ESC로 닫기
 */
export default function MrtDialog({
  open,
  ariaLabel,
  onClose,
  zIndex = 32000,
  closeOnBackdrop = true,
  overlayStyle,
  panelStyle,
  children,
}) {
  useEffect(() => {
    if (!open) return;
    const onKeyDown = (e) => {
      if (e.key === 'Escape') onClose?.();
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [open, onClose]);

  if (!open) return null;

  return createPortal(
    <div
      role="dialog"
      aria-modal="true"
      aria-label={ariaLabel || 'dialog'}
      onMouseDown={(e) => {
        if (!closeOnBackdrop) return;
        if (e.target === e.currentTarget) onClose?.();
      }}
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0, 0, 0, 0.55)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex,
        padding: '60px 14px 14px',
        ...(overlayStyle || {}),
      }}
    >
      <div
        onMouseDown={(e) => e.stopPropagation()}
        style={{
          width: 'min(520px, 92vw)',
          background: 'var(--mrt-surface)',
          borderRadius: '16px',
          border: '1px solid var(--mrt-border)',
          boxShadow: '0 18px 50px rgba(0,0,0,0.45)',
          overflow: 'hidden',
          ...(panelStyle || {}),
        }}
      >
        {children}
      </div>
    </div>,
    document.body,
  );
}












